import { render } from "./UsersListView.vue?vue&type=template&id=1032f129&ts=true"
import script from "./UsersListView.vue?vue&type=script&lang=ts"
export * from "./UsersListView.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__